import { BaseModelOptions, GenerateModelEvent } from '@projectstorm/react-canvas-core';
import { AbstractReactFactory, GenerateWidgetEvent, AbstractModelFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams';
import styled from '@emotion/styled';
import { MetricsNodeModel } from './MetricsNodeModel';
import { MetricNodeWidget } from './MetricsNodeWidget';

export class MetricsNodeFactory extends AbstractReactFactory<MetricsNodeModel, DiagramEngine> {
    constructor() {
        super('redquick-model');
    }

    generateModel(): MetricsNodeModel {
        return new MetricsNodeModel();
    }

    generateReactWidget(event: GenerateWidgetEvent<MetricsNodeModel>): JSX.Element {
        return <MetricNodeWidget node={event.model} engine={this.engine} />;
    }
}


export namespace S {
    export const Node = styled.div<{ background: string; selected: boolean }>`
		background-color: ${(p) => p.background};
		border-radius: 5px;
		font-family: sans-serif;
		color: white;
		border: solid 2px black;
		overflow: visible;
		font-size: 11px;
		border: solid 2px ${(p) => (p.selected ? 'rgb(0,192,255)' : 'black')};
	`;

    export const Title = styled.div`
		background: rgba(0, 0, 0, 0.3);
		display: flex;
		white-space: nowrap;
		justify-items: center;
        position: relative;
	`;

    export const TitleName = styled.div`
		flex-grow: 1;
		padding: 5px 5px;
	`;
    export const TitleDetailName = styled.div`
		flex-grow: 1;
        color: blue;
		padding: 5px 5px;
	`;

    export const Ports = styled.div`
		display: flex;
		background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));
	`;

    export const PortsContainer = styled.div`
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		&:first-of-type {
			margin-right: 10px;
		}
		&:only-child {
			margin-right: 0px;
		}
	`;
    export const PortLabel = styled.div`
		display: flex;
		margin-top: 1px;
		align-items: center;
        &:hover {
            background-color: rgba(0,0,0,.1);
        }
	`;

    export const Label = styled.div`
		padding: 0 5px;
		flex-grow: 1;
        max-width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
	`;

    export const Port = styled.div`
		width: 15px;
		height: 15px;
		background: rgba(255, 255, 255, 0.1);
		&:hover {
			background: rgb(192, 255, 0);
		}
	`;
}